var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "side-wrap" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "0", size: "mini" },
        },
        [
          _c(
            "div",
            { staticClass: "side-head" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-search",
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.onSearch },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-reset",
                  attrs: { type: "primary", size: "mini", plain: "" },
                  on: { click: _vm.onReset },
                },
                [_vm._v("重置")]
              ),
              _c("div", {
                staticClass: "icon-side-collapse",
                on: { click: _vm.hideCollapse },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "menu-conent-top" },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入内容" },
                      model: {
                        value: _vm.form.userInfoKeywords,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "userInfoKeywords", $$v)
                        },
                        expression: "form.userInfoKeywords",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "mini-select",
                          attrs: { slot: "prepend", placeholder: "请选择" },
                          slot: "prepend",
                          model: {
                            value: _vm.form.userInfoType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "userInfoType", $$v)
                            },
                            expression: "form.userInfoType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.ol_user_info_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入内容" },
                      model: {
                        value: _vm.form.codeKeywords,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "codeKeywords", $$v)
                        },
                        expression: "form.codeKeywords",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { slot: "prepend", placeholder: "请选择" },
                          slot: "prepend",
                          model: {
                            value: _vm.form.codeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "codeType", $$v)
                            },
                            expression: "form.codeType",
                          },
                        },
                        _vm._l(_vm.dictionaries.ol_code_type, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入内容" },
                      model: {
                        value: _vm.form.postAddressKeywords,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "postAddressKeywords", $$v)
                        },
                        expression: "form.postAddressKeywords",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { slot: "prepend", placeholder: "请选择" },
                          slot: "prepend",
                          model: {
                            value: _vm.form.postAddressType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "postAddressType", $$v)
                            },
                            expression: "form.postAddressType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.ol_post_addr_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "input-with-select" },
                  [
                    _c("span", { staticClass: "prepend-text" }, [
                      _vm._v("所属部门"),
                    ]),
                    _c("el-cascader", {
                      staticClass: "select",
                      class: {
                        "select-one": _vm.orgCodeArry.length == 1,
                        "select-two": _vm.orgCodeArry.length > 1,
                        "select-ten": _vm.orgCodeArry.length > 10,
                      },
                      attrs: {
                        options: _vm.orgCodeList,
                        props: {
                          label: "orgName",
                          value: "orgCode",
                          multiple: true,
                          checkStrictly: true,
                        },
                        placeholder: "请选择部门",
                        "show-all-levels": false,
                        "collapse-tags": "",
                      },
                      on: { change: _vm.onChangeOrgCode },
                      model: {
                        value: _vm.orgCodeArry,
                        callback: function ($$v) {
                          _vm.orgCodeArry = $$v
                        },
                        expression: "orgCodeArry",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "menu-conent" }, [
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "order" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("order")
                      },
                    },
                  },
                  [
                    _vm._v("订单状态"),
                    _c("el-badge", {
                      staticClass: "badge",
                      attrs: {
                        hidden: !_vm.orderStatistics.total > 0,
                        value: _vm.orderStatistics.total,
                      },
                    }),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ],
                  1
                ),
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "group-con",
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.form.orderStatuses,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderStatuses", $$v)
                      },
                      expression: "form.orderStatuses",
                    },
                  },
                  _vm._l(_vm.dictionaries.ol_order_status, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item.dictId,
                        attrs: { label: item.dictId, value: item.dictId },
                      },
                      [
                        _vm._v(" " + _vm._s(item.dictName) + " "),
                        _c("el-badge", {
                          staticClass: "badge",
                          attrs: {
                            hidden: !_vm.orderStatistics[item.dictId] > 0,
                            value: _vm.orderStatistics[item.dictId],
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "abnormal" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("abnormal")
                      },
                    },
                  },
                  [
                    _vm._v("异常订单"),
                    _c("el-badge", {
                      staticClass: "badge",
                      attrs: {
                        hidden: !_vm.exceptionStatistics.total > 0,
                        value: _vm.exceptionStatistics.total,
                      },
                    }),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ],
                  1
                ),
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "group-con",
                    model: {
                      value: _vm.form.orderExcs,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderExcs", $$v)
                      },
                      expression: "form.orderExcs",
                    },
                  },
                  _vm._l(_vm.dictionaries.ol_exc_order, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item.dictId,
                        attrs: { label: item.dictId, value: item.dictId },
                      },
                      [
                        _vm._v(" " + _vm._s(item.dictName) + " "),
                        _c("el-badge", {
                          staticClass: "badge",
                          attrs: {
                            hidden: !_vm.exceptionStatistics[item.dictId] > 0,
                            value: _vm.exceptionStatistics[item.dictId],
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "orderInfo" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("orderInfo")
                      },
                    },
                  },
                  [
                    _vm._v("订单信息"),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ]
                ),
                _c("div", { staticClass: "group-con group-con-form" }, [
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("商品名称")]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.orderInfos.goodsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.orderInfos, "goodsName", $$v)
                          },
                          expression: "form.orderInfos.goodsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("商品五域编号"),
                      ]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.orderInfos.wyGoodsCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.orderInfos, "wyGoodsCode", $$v)
                          },
                          expression: "form.orderInfos.wyGoodsCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("规格名称")]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.orderInfos.goodsSkuName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.orderInfos, "goodsSkuName", $$v)
                          },
                          expression: "form.orderInfos.goodsSkuName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("规格编码")]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.orderInfos.skuCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.orderInfos, "skuCode", $$v)
                          },
                          expression: "form.orderInfos.skuCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("订单类型")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.orderInfos.orderGenerateType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.orderInfos,
                                "orderGenerateType",
                                $$v
                              )
                            },
                            expression: "form.orderInfos.orderGenerateType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.oms_order_generate_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("订单来源")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.orderInfos.orderOrigin,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.orderInfos, "orderOrigin", $$v)
                            },
                            expression: "form.orderInfos.orderOrigin",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.oms_all_order_origin,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("第三方平台"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.orderInfos.thirdParty,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.orderInfos, "thirdParty", $$v)
                            },
                            expression: "form.orderInfos.thirdParty",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "有", value: 1 } }),
                          _c("el-option", { attrs: { label: "无", value: 0 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("下单时间")]),
                      _c("el-date-picker", {
                        staticClass: "data-picker",
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "range-separator": "至",
                          "default-time": ["00:00:00", "23:59:59"],
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeTime("orderCreatedTime")
                          },
                        },
                        model: {
                          value: _vm.orderCreatedTime,
                          callback: function ($$v) {
                            _vm.orderCreatedTime = $$v
                          },
                          expression: "orderCreatedTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("付款时间")]),
                      _c("el-date-picker", {
                        staticClass: "data-picker",
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "range-separator": "至",
                          "default-time": ["00:00:00", "23:59:59"],
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeTime("orderPayTime")
                          },
                        },
                        model: {
                          value: _vm.orderPayTime,
                          callback: function ($$v) {
                            _vm.orderPayTime = $$v
                          },
                          expression: "orderPayTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("支付方式")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.orderInfos.payType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.orderInfos, "payType", $$v)
                            },
                            expression: "form.orderInfos.payType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.oms_order_pay_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("支付流水号"),
                      ]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.orderInfos.paymentTransactionId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.orderInfos,
                              "paymentTransactionId",
                              $$v
                            )
                          },
                          expression: "form.orderInfos.paymentTransactionId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("内购价")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.orderInfos.purchaseFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.orderInfos, "purchaseFlag", $$v)
                            },
                            expression: "form.orderInfos.purchaseFlag",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("是否到付")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.orderInfos.codFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.orderInfos, "codFlag", $$v)
                            },
                            expression: "form.orderInfos.codFlag",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("税号")]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.orderInfos.taxpayerNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.orderInfos, "taxpayerNumber", $$v)
                          },
                          expression: "form.orderInfos.taxpayerNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("配送方式")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.orderInfos.deliveryType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.orderInfos, "deliveryType", $$v)
                            },
                            expression: "form.orderInfos.deliveryType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "邮寄", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "自提", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "remark" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("remark")
                      },
                    },
                  },
                  [
                    _vm._v("留言备注"),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ]
                ),
                _c("div", { staticClass: "group-con group-con-form" }, [
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("买家留言")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasBuyerMessage,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.remarks, "hasBuyerMessage", $$v)
                            },
                            expression: "form.remarks.hasBuyerMessage",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有留言", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无留言", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("商家备注")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasMerchantRemark,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.remarks,
                                "hasMerchantRemark",
                                $$v
                              )
                            },
                            expression: "form.remarks.hasMerchantRemark",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有备注", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无备注", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("客服备注")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasServiceRemark,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.remarks,
                                "hasServiceRemark",
                                $$v
                              )
                            },
                            expression: "form.remarks.hasServiceRemark",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有备注", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无备注", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("客服订单审核备注"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasAuditRemark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.remarks, "hasAuditRemark", $$v)
                            },
                            expression: "form.remarks.hasAuditRemark",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有备注", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无备注", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("申诉备注")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasAppealRemark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.remarks, "hasAppealRemark", $$v)
                            },
                            expression: "form.remarks.hasAppealRemark",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有备注", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无备注", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("提成审批备注"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasBonusAuditRemark,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.remarks,
                                "hasBonusAuditRemark",
                                $$v
                              )
                            },
                            expression: "form.remarks.hasBonusAuditRemark",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有备注", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无备注", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("修改备注")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasCommissionRemark,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.remarks,
                                "hasCommissionRemark",
                                $$v
                              )
                            },
                            expression: "form.remarks.hasCommissionRemark",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有修改", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无修改", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("售后件备注"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remarks.hasAfterSalesRemark,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.remarks,
                                "hasAfterSalesRemark",
                                $$v
                              )
                            },
                            expression: "form.remarks.hasAfterSalesRemark",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有备注", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "无备注", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "kefu" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("kefu")
                      },
                    },
                  },
                  [
                    _vm._v("客服信息"),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ]
                ),
                _c("div", { staticClass: "group-con group-con-form" }, [
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("客服部门")]),
                      _c("el-cascader", {
                        attrs: {
                          size: "mini",
                          options: _vm.orgCodeList,
                          props: {
                            label: "orgName",
                            value: "orgCode",
                            children: "children",
                            multiple: false,
                            checkStrictly: true,
                          },
                          placeholder: "请输入内容",
                          "show-all-levels": false,
                          "collapse-tags": "",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeOrgCode($event, "kefu")
                          },
                        },
                        model: {
                          value: _vm.sysUserOrgArry,
                          callback: function ($$v) {
                            _vm.sysUserOrgArry = $$v
                          },
                          expression: "sysUserOrgArry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("跟进客服")]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.serviceInfos.followUpServiceName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.serviceInfos,
                              "followUpServiceName",
                              $$v
                            )
                          },
                          expression: "form.serviceInfos.followUpServiceName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("客服下单时间"),
                      ]),
                      _c("el-date-picker", {
                        staticClass: "data-picker",
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "range-separator": "至",
                          "default-time": ["00:00:00", "23:59:59"],
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeTime("serviceOrderTime")
                          },
                        },
                        model: {
                          value: _vm.serviceOrderTime,
                          callback: function ($$v) {
                            _vm.serviceOrderTime = $$v
                          },
                          expression: "serviceOrderTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("提成类型")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.serviceInfos.bonusType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.serviceInfos, "bonusType", $$v)
                            },
                            expression: "form.serviceInfos.bonusType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.oms_bonus_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("提成审批状态"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.serviceInfos.bonusReviewStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.serviceInfos,
                                "bonusReviewStatus",
                                $$v
                              )
                            },
                            expression: "form.serviceInfos.bonusReviewStatus",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.oms_bonus_review_status,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("提成审核人"),
                      ]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.serviceInfos.bonusAuditorName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.serviceInfos,
                              "bonusAuditorName",
                              $$v
                            )
                          },
                          expression: "form.serviceInfos.bonusAuditorName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("修改人")]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.serviceInfos.bonusModifierName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.serviceInfos,
                              "bonusModifierName",
                              $$v
                            )
                          },
                          expression: "form.serviceInfos.bonusModifierName",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "logistics" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("logistics")
                      },
                    },
                  },
                  [
                    _vm._v("物流信息"),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ]
                ),
                _c("div", { staticClass: "group-con group-con-form" }, [
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("最晚发货时间"),
                      ]),
                      _c("el-date-picker", {
                        staticClass: "data-picker",
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "range-separator": "至",
                          "default-time": ["00:00:00", "23:59:59"],
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeTime("latestDeliveryTime")
                          },
                        },
                        model: {
                          value: _vm.latestDeliveryTime,
                          callback: function ($$v) {
                            _vm.latestDeliveryTime = $$v
                          },
                          expression: "latestDeliveryTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("发货时间")]),
                      _c("el-date-picker", {
                        staticClass: "data-picker",
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "range-separator": "至",
                          "default-time": ["00:00:00", "23:59:59"],
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeTime("deliveryTime")
                          },
                        },
                        model: {
                          value: _vm.deliveryTime,
                          callback: function ($$v) {
                            _vm.deliveryTime = $$v
                          },
                          expression: "deliveryTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("发货仓")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.logisticsInfos.warehouseId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.logisticsInfos,
                                "warehouseId",
                                $$v
                              )
                            },
                            expression: "form.logisticsInfos.warehouseId",
                          },
                        },
                        _vm._l(_vm.warehouseList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.warehouseName,
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("快递公司")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            filterable: "",
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.logisticsInfos.logisticsCompanyCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.logisticsInfos,
                                "logisticsCompanyCode",
                                $$v
                              )
                            },
                            expression:
                              "form.logisticsInfos.logisticsCompanyCode",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.courier_company,
                          function (item, index) {
                            return _c("el-option", {
                              key: item.dictId + "-" + index,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("物流单号")]),
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          size: "mini",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.logisticsInfos.logisticsNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.logisticsInfos,
                              "logisticsNumber",
                              $$v
                            )
                          },
                          expression: "form.logisticsInfos.logisticsNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("指定快递")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            filterable: "",
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.logisticsInfos.specifiedLogisticsId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.logisticsInfos,
                                "specifiedLogisticsId",
                                $$v
                              )
                            },
                            expression:
                              "form.logisticsInfos.specifiedLogisticsId",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.oms_logistics_company,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "afterSales" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("afterSales")
                      },
                    },
                  },
                  [
                    _vm._v("售后信息"),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ]
                ),
                _c("div", { staticClass: "group-con group-con-form" }, [
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("是否存在退货"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.afterSalesInfos.hasAfterSales,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.afterSalesInfos,
                                "hasAfterSales",
                                $$v
                              )
                            },
                            expression: "form.afterSalesInfos.hasAfterSales",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("发起退货时间"),
                      ]),
                      _c("el-date-picker", {
                        staticClass: "data-picker",
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "range-separator": "至",
                          "default-time": ["00:00:00", "23:59:59"],
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeTime("afterSalesApplyTime")
                          },
                        },
                        model: {
                          value: _vm.afterSalesApplyTime,
                          callback: function ($$v) {
                            _vm.afterSalesApplyTime = $$v
                          },
                          expression: "afterSalesApplyTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("售后类型")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.afterSalesInfos.afterSalesStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.afterSalesInfos,
                                "afterSalesStatus",
                                $$v
                              )
                            },
                            expression: "form.afterSalesInfos.afterSalesStatus",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.oms_after_sales_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("售后件登记"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.afterSalesInfos.itemCondition,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.afterSalesInfos,
                                "itemCondition",
                                $$v
                              )
                            },
                            expression: "form.afterSalesInfos.itemCondition",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "完好", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "破损", value: 2 },
                          }),
                          _c("el-option", {
                            attrs: { label: "漏件", value: 3 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("是否理赔")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.afterSalesInfos.isClaim,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.afterSalesInfos, "isClaim", $$v)
                            },
                            expression: "form.afterSalesInfos.isClaim",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                          _c("el-option", { attrs: { label: "是", value: 2 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-form" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("售后阶段")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-mini",
                          attrs: {
                            placeholder: "请选择",
                            size: "mini",
                            clearable: "",
                          },
                          model: {
                            value:
                              _vm.form.afterSalesInfos.afterSalesSubsetStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.afterSalesInfos,
                                "afterSalesSubsetStatus",
                                $$v
                              )
                            },
                            expression:
                              "form.afterSalesInfos.afterSalesSubsetStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "无售后", value: 0 },
                          }),
                          _c("el-option", {
                            attrs: { label: "审核中", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "待寄回", value: 2 },
                          }),
                          _c("el-option", {
                            attrs: { label: "退货中", value: 3 },
                          }),
                          _c("el-option", {
                            attrs: { label: "待换货", value: 4 },
                          }),
                          _c("el-option", {
                            attrs: { label: "换货中", value: 5 },
                          }),
                          _c("el-option", {
                            attrs: { label: "售后关闭", value: 6 },
                          }),
                          _c("el-option", {
                            attrs: { label: "商家拒绝售后", value: 7 },
                          }),
                          _c("el-option", {
                            attrs: { label: "售后完成", value: 8 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "item-menu",
                class: { active: _vm.chooseMenu == "tag" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu-name",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMenu("tag")
                      },
                    },
                  },
                  [
                    _vm._v("标签"),
                    _c("i", { staticClass: "el-icon-arrow-right icon" }),
                  ]
                ),
                _c("div", { staticClass: "group-con group-con-form" }, [
                  _c("div", { staticClass: "item-form" }, [
                    _c("div", { staticClass: "lable" }, [_vm._v("包含标签")]),
                    _c(
                      "div",
                      {
                        staticClass: "select-box",
                        on: {
                          click: function ($event) {
                            return _vm.onSelectTag("includeTag")
                          },
                        },
                      },
                      [
                        _vm.includeTag.tagIds &&
                        _vm.includeTag.tagIds.length > 0
                          ? [
                              _vm.includeTag.radio
                                ? [
                                    _c("span", {
                                      class:
                                        "tag-no tag-" + _vm.includeTag.radio,
                                    }),
                                  ]
                                : _vm._e(),
                              _vm.includeTag.check &&
                              _vm.includeTag.check.length > 0
                                ? _vm._l(
                                    _vm.includeTag.checkList,
                                    function (tag, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          class: `tag-text tag-${
                                            tag.tagType == 3 ? "red" : "black"
                                          }`,
                                        },
                                        [_vm._v(_vm._s(tag.tagName))]
                                      )
                                    }
                                  )
                                : _vm._e(),
                              _c("i", {
                                staticClass:
                                  "el-icon-circle-close select-close",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.clearTag("includeTag")
                                  },
                                },
                              }),
                            ]
                          : [
                              _c("div", { staticClass: "text" }, [
                                _vm._v("请选择"),
                              ]),
                              _c("i", {
                                staticClass: "el-icon-arrow-down select-arrow",
                              }),
                            ],
                      ],
                      2
                    ),
                  ]),
                  _c("div", { staticClass: "item-form" }, [
                    _c("div", { staticClass: "lable" }, [_vm._v("排除标签")]),
                    _c(
                      "div",
                      {
                        staticClass: "select-box",
                        on: {
                          click: function ($event) {
                            return _vm.onSelectTag("excludeTag")
                          },
                        },
                      },
                      [
                        _vm.excludeTag.tagIds &&
                        _vm.excludeTag.tagIds.length > 0
                          ? [
                              _vm.excludeTag.radio
                                ? [
                                    _c("span", {
                                      class:
                                        "tag-no tag-" + _vm.excludeTag.radio,
                                    }),
                                  ]
                                : _vm._e(),
                              _vm.excludeTag.check &&
                              _vm.excludeTag.check.length > 0
                                ? _vm._l(
                                    _vm.excludeTag.checkList,
                                    function (tag, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          class: `tag-text tag-${
                                            tag.tagType == 3 ? "red" : "black"
                                          }`,
                                        },
                                        [_vm._v(_vm._s(tag.tagName))]
                                      )
                                    }
                                  )
                                : _vm._e(),
                              _c("i", {
                                staticClass:
                                  "el-icon-circle-close select-close",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.clearTag("excludeTag")
                                  },
                                },
                              }),
                            ]
                          : [
                              _c("div", { staticClass: "text" }, [
                                _vm._v("请选择"),
                              ]),
                              _c("i", {
                                staticClass: "el-icon-arrow-down select-arrow",
                              }),
                            ],
                      ],
                      2
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }